import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { authAxiosWithoutInterceptors } from "./axios.js";

interface IGetCheckPartnerFirstConnectionQuery {
  socialApplyId: ObjectId;
}

export const useGetCheckPartnerFirstConnection = () => {
  const [state, execute, cancel] = authAxiosWithoutInterceptors<void, void, unknown>({
    url: "/user/partner/firstConnection",
    method: "GET",
  });

  const callback = useCallback(
    (query: IGetCheckPartnerFirstConnectionQuery) => {
      return execute({
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
